
import Path2 from "../../../assets/filled/Path2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Path2Icon({ className, dataTestid = "Path2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Path2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
